import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
    layout: 'grid',
    buttonText: '',
    items: [],
  },
  blockDesign: {
    view: 'card',
  },
  itemDesign: {},
  buttonDesign: {},
  containerDesign: {},
};

export const appsSlice = createSlice({
  name: 'apps',
  initialState,
  reducers: {
    appsStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, buttonDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.buttonDesign = buttonDesign ?? {};
      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        heading: {
          ...blockContent.heading,
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
        layout: blockContent.layout ?? 'grid',
        buttonText: blockContent.buttonText ?? '',
        items: blockContent.items ?? [],
      };

      state.blockDesign = {
        view: blockDesign.view ?? 'card',
      };
    },
    appsClear: () => initialState,

    appsUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    appsUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    appsUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    appsUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const { appsStore, appsClear, appsUpdateIsLoading, appsUpdateIsActive, appsUpdateBlockContent, appsUpdateBlockDesign } = appsSlice.actions;

export const selectAppsIsLoading = (state) => state.apps.isLoading;

export const selectAppsId = (state) => state.apps.id;
export const selectAppsUID = (state) => state.apps.uid;
export const selectAppsSID = (state) => state.apps.sid;

export const selectAppsBlockContent = (state) => state.apps.blockContent;

export const selectAppsSortItems = createSelector([selectAppsBlockContent], ({ items }) => {
  return sortItems(items);
});

export const selectAppsBlockDesign = (state) => state.apps.blockDesign;
export const selectAppsButtonDesign = (state) => state.apps.buttonDesign;
export const selectAppsItemDesign = (state) => state.apps.itemDesign;
export const selectAppsContainerDesign = (state) => state.apps.containerDesign;

export default appsSlice.reducer;
